import { notificationReducer } from '@quiz-frontend/quiz-builder/store/notification/reducer';
import { quizReducer } from '@quiz-frontend/quiz-builder/store/quiz/reducer';
import { combineReducers } from 'redux';

import { appReducer } from './app/reducer';

export const reducers = {
  app: appReducer,
  quizState: quizReducer,
  notifications: notificationReducer,
};

type ReducerType = typeof reducers;
export type RootState = { [K in keyof ReducerType]: ReturnType<ReducerType[K]> };

const createRootReducer = () => combineReducers(reducers);

export default createRootReducer;
